import { IteratorForm } from "../../@components/AiToolkit/Iterator/IteratorForm";

export function Iterator() {
  return <IteratorForm />;
}
